"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function default_1(elementId) {
    window.setTimeout(() => {
        var _a;
        (_a = document.getElementById(elementId)) === null || _a === void 0 ? void 0 : _a.scrollIntoView({ block: 'center', behavior: 'smooth' });
    }, 0);
}
exports.default = default_1;
